import { BaseFieldWidget, ModelFieldType, ViewType, SPI, FormStringUploadFieldWidget } from '@kunlun/dependencies';
import CustomUploadImage from './CustomUploadImage.vue';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    viewType: [ViewType.Form],
    ttype: ModelFieldType.String,
    widget: ['CustomUploadImage']
  })
)
export class FormStringUploadImgFieldWdiget extends FormStringUploadFieldWidget {
  public initialize(config) {
    super.initialize(config);
    this.setComponent(CustomUploadImage);
    return this;
  }
}
